import { profileConstants } from "../_constants";
("use strict");

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import {
  ajaxError,
  getProfilDetailsError,
  getProfileDetailsComplete,
  updateDisplayNameComplete,
  updateDisplayNameError,
  updateProfilePictureComplete,
} from "../_actions";

export const getProfileDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(profileConstants.GET_PROFILE_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/profile/getProfileDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            getProfileDetailsComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(getProfilDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const updateProfilePictureEpic = (actions$) =>
  actions$.pipe(
    ofType(profileConstants.UPDATE_PROFILE_PICTURE_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/profile/updateProfilePicture",
          action.payload,
          getRequestHeader("UPLOAD"),
        )
        .pipe(
          map((ajaxResponse) =>
            updateProfilePictureComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(getProfilDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const getProfileNicknameUpdateEpic = (actions$) =>
  actions$.pipe(
    ofType(profileConstants.UPDATE_DISPLAY_NAME_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/profile/updateNickname",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            updateDisplayNameComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(updateDisplayNameError(error), ajaxError(error)),
          ),
        );
    }),
  );
